import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Fade, Stack, Typography } from '@mui/material';

import {
  createFlexibleStripeSession,
  createSubscriptionStripeSession,
} from '../../../../store/V2/StripeSlice';
import { IFlexiblePlan } from '../../../../store/V2/FlexiblePlansSlice';
import { ISubscriptionPlan } from '../../../../store/V2/SubscriptionPlansSlice';
import { SafeAreaGaps } from '../../../../helper';
import DarkLoadingButton, {
  defaultButtonStyles,
} from '../../../../components/V2/Buttons';

interface PlanPurchaseFooterProps {
  flexiblePlan?: IFlexiblePlan;
  subscriptionPlan?: ISubscriptionPlan;
  userId?: string;
}

const planPurchaseFooterContainerStyles: React.CSSProperties = {
  position: 'fixed',
  width: '100%',
  bottom: `${SafeAreaGaps.bottom}`,
  backgroundColor: '#ffffff',
  left: `${SafeAreaGaps.left}`,
  padding: '16px 30px',
  boxShadow: '0px -14px 40px 0px #6E9DB22E',
};

const PlanPurchaseFooter: React.FunctionComponent<PlanPurchaseFooterProps> = ({
  flexiblePlan,
  subscriptionPlan,
  userId,
}) => {
  const dispatch = useDispatch();

  // State
  const [isLoading, setLoading] = useState(false);

  let amount = '';
  let currency = '';
  let handlePurchase;

  const onFlexiblePlanPurchase = async () => {
    setLoading(true);

    if (flexiblePlan) {
      await dispatch(
        createFlexibleStripeSession({
          planId: flexiblePlan._id,
          ...(userId && { userId }),
        })
      );
    }

    setLoading(false);
  };

  const onSubscriptionPlanPurchase = async () => {
    setLoading(true);

    if (subscriptionPlan) {
      await dispatch(
        createSubscriptionStripeSession({
          planId: subscriptionPlan._id,
          ...(userId && { userId }),
        })
      );
    }

    setLoading(false);
  };

  if (flexiblePlan && flexiblePlan.amount && flexiblePlan.currency) {
    amount = flexiblePlan.amount.toString();
    currency = flexiblePlan.currency;
    handlePurchase = onFlexiblePlanPurchase;
  } else if (
    subscriptionPlan &&
    subscriptionPlan.amount &&
    subscriptionPlan.currency
  ) {
    amount = subscriptionPlan.amount.toString();
    currency = subscriptionPlan.currency;
    handlePurchase = onSubscriptionPlanPurchase;
  }

  return (
    <Fade in>
      <div style={planPurchaseFooterContainerStyles}>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          gap="32px"
        >
          <Stack>
            <Typography
              fontWeight={700}
              color="#334155"
              sx={{ fontSize: { xs: '20px', sm: '40px' } }}
            >
              {currency.toUpperCase()} {amount}
            </Typography>
          </Stack>
          <DarkLoadingButton
            variant="contained"
            color="inherit"
            loading={isLoading}
            sx={{ ...defaultButtonStyles }}
            onClick={handlePurchase}
          >
            Subscribe & Pay
          </DarkLoadingButton>
        </Stack>
      </div>
    </Fade>
  );
};

export default PlanPurchaseFooter;
